import React from 'react';

function Heart() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="33.891"
			height="41.438"
			viewBox="0 0 33.891 41.438"
		>
			<path fill="none" d="M0 0H33.891V41.438H0z"></path>
			<g data-name="Group 6">
				<g data-name="Layer 2">
					<g>
						<path
							d="M16.945 32.226L2.754 18.009A10.8 10.8 0 0116.945 1.915a10.8 10.8 0 0114.192 16.094l-.06.063zM5.12 15.833l11.825 11.843 11.826-11.843A7.587 7.587 0 0018.018 5.157l-1.074.966-1.074-.966A7.587 7.587 0 005.12 15.833"
							transform="translate(0 -.002)"
						></path>
					</g>
				</g>
			</g>
		</svg>
	);
}

export default Heart;
